import { SVGProps } from 'react';

export const UserIcon = ({ ...rest }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx="12" cy="9" r="4.75" stroke="#1A1919" strokeWidth="1.5" />
      <path
        d="M19 20.5C19 17.1863 15.866 14.5 12 14.5C8.13401 14.5 5 17.1863 5 20.5"
        stroke="#1A1919"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
